import type { Filter } from "core/models/filters";

export type PartnersFilters = Filter<{
	status: "other" | "active"
}>;

export enum AplicationStatusColor {
	UnderReview = "warning",
	Approved = "success",
	Rejected = "error",
	Inactive = "default"
}